// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38C0_","type":"styles_type__2ptyX","choices":"styles_choices__jo37m"};